'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowDownRectangle, iconArrowDownRectangleTag } from '@ni/nimble-components/dist/esm/icons/arrow-down-rectangle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowDownRectangle };
export { iconArrowDownRectangleTag };
export const NimbleIconArrowDownRectangle = wrap(IconArrowDownRectangle);